<template>
  <div
    class="row drop-container-wrapper"
    @drop="drop"
    @dragover="allowDrop"
    @dragleave="dragleave"
    @dragenter="allowDrop"
  >
    <div
      v-if="showDropFile"
      class="col-12 main-content drop-container"
    >
      {{ 'drop_file_placeholder' | i18n }}
    </div>
    <div class="col-12 main-content">
      <validated-form
        id="catalogue-form"
        :submit="onSubmit"
      >
        <template v-slot:form>
          <div
            class="row mb-3"
          >
            <div class="col-12 col-md-6 col-xl-4">
              <validated-text-input
                v-model="formData.name"
                :name="'name' | i18n"
                input-id="catalogue-name"
                rules="required"
                :label="'name' | i18n"
              />
            </div>
            <div class="col-12 col-md-6 col-xl-4">
              <b-form-group
                id="description"
                :label="'description' | i18n"
                label-for="title-description"
              >
                <text-input
                  v-model="formData.description"
                  :name="'description' | i18n"
                  input-id="catalogue-description"
                  form-group-id="title-description"
                />
              </b-form-group>
            </div>
            <div class="col-12 col-md-6 col-xl-4">
              <validated-file-input
                v-model="formData.file"
                :label="'file' | i18n"
                :name="'file' | i18n"
                input-id="catalogue-file"
                label-for="catalogue-file-input"
                file-extensions="image/jpeg, image/jpg, image/png, application/pdf"
                rules="required"
              />
            </div>
          </div>
        </template>
        <template v-slot:buttons="{invalid}">
          <div class="row">
            <div class="col-12 justify-content-end form-buttons">
              <b-form-group class="form-button-group">
                <b-button
                  type="submit"
                  variant="primary"
                  size="sm"
                  :disabled="invalid"
                >
                  {{ 'save' | i18n }}
                </b-button>
              </b-form-group>
            </div>
          </div>
        </template>
      </validated-form>
    </div>
  </div>
</template>

<script>

import {CatalogueMixin, NotificationMixin} from '../../mixins';
import ValidatedTextInput from '../forms/validation/validated-text-input';
import ValidatedForm from '../forms/validation/validated-form';
import ValidatedFileInput from '../forms/validation/validated-file-input';
import TextInput from '../inputs/text';

export default {
  name: 'UploadCatalogue',
  components: {ValidatedFileInput, ValidatedForm, ValidatedTextInput, TextInput},
  mixins: [CatalogueMixin, NotificationMixin],
  data: function () {
    return {
      formData: {
        name: null,
        description: null,
        file: null
      },
      showDropFile: false,
      dropIntervalId: null,
      fileInputTouched: false
    };
  },
  methods: {
    hideDrop(){
      if(this.dropIntervalId){
        clearTimeout(this.dropIntervalId);
      }
      this.dropIntervalId = setTimeout(() => {
        this.showDropFile = false;
      }, 300);
    },
    drop(event) {
      event.preventDefault();
      this.hideDrop();
      const allowedFormats = 'image/jpeg, image/jpg, image/png, application/pdf';
      const file = event.dataTransfer.files[0];
      if(!file.type || allowedFormats.indexOf(file.type) === -1){
        this.showNotification({type: 'error', title: this.$translate('upload'), message: this.$translate('format_not_allowed')});
        return;
      }

      this.formData.file = file;
      if(!this.formData.name){
        this.formData.name = file.name;
      }
    },
    allowDrop(event) {
      event.preventDefault();
      if(this.dropIntervalId){
        clearTimeout(this.dropIntervalId);
      }
      this.showDropFile = true;
    },
    dragleave(event) {
      event.preventDefault();
      this.hideDrop();
    },
    async onSubmit() {
      try {
        const formData = new FormData();
        formData.append('file', this.formData.file);
        formData.append('name', this.formData.name);
        formData.append('description', this.formData.description || '');
        await this.catalogueService.uploadCatalogue(formData);
        this.showNotification({type: 'success', title: this.$translate('success'), message: this.$translate('catalogue_uploaded')});
        this.resetForm();
        this.$emit('uploaded');
      } catch (err) {
        this.showNotification({type: 'error', message: err.message});
      }
    },
    resetForm() {
      Object.keys(this.formData).forEach(key => this.formData[key] = null);
    }
  }
};
</script>

<style scoped lang="scss">
  .form-buttons .form-group {
    float: right;
  }

  @media(max-width: 768px) {
    .form-buttons .btn {
      margin: 0;
    }
  }

  .form-group {
    margin-bottom: 0;
  }
  .drop-container{
    position: absolute;
    z-index: 10;
    background: rgba(0,0,0,0.4);
    color: white;
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    font-size: 35px;
  }

  .drop-container-wrapper{
    position: relative;
  }
</style>
